import React from "react";
import { Header, NavLinks } from "../components";
import './AppWrap.scss'

//Este seria el esqueleto de la app es decir el espacio para el header el menu y el main
const AppWrap = (Component) =>
  function HOC() {
    return (
      <div className="app-wrapper">
        <div className="header-container">
          <Header />
        </div>
        <div className="content-container">
          <Component />
        </div>
        <div className="menu-container">
          <NavLinks />
        </div>
      </div>
    );
  };

export default AppWrap;
